import { createContext, useContext, useEffect, useState } from 'react';

import { CampItemResponse } from '../../api/camps';

export const CurrentCampDetailsContext = createContext<{
  campDetails: CampItemResponse | null;
  setCampDetails: (campDetails: CampItemResponse | null) => void;
}>({
  campDetails: null,
  setCampDetails: () => {},
});

export const useCurrentCampDetails = () => {
  const { campDetails, setCampDetails } = useContext(CurrentCampDetailsContext);
  return { campDetails, setCampDetails };
};

export const useSyncCurrentCampDetails = (
  campDetails: CampItemResponse | null
) => {
  const { setCampDetails } = useCurrentCampDetails();
  useEffect(() => {
    setCampDetails(campDetails);
  }, [campDetails, setCampDetails]);
};

export default function CurrentCampDetailsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [campDetails, setCampDetails] = useState<CampItemResponse | null>(null);

  return (
    <CurrentCampDetailsContext.Provider value={{ campDetails, setCampDetails }}>
      {children}
    </CurrentCampDetailsContext.Provider>
  );
}
